import { render } from "./admin-operation-log.vue?vue&type=template&id=47d40766&scoped=true&ts=true"
import script from "./admin-operation-log.vue?vue&type=script&lang=ts"
export * from "./admin-operation-log.vue?vue&type=script&lang=ts"

import "./admin-operation-log.vue?vue&type=style&index=0&id=47d40766&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d40766"]])

export default __exports__